import angular from 'angular';

import CalendarDayEventComponent from './calendar-day-event.cmpt';

export default angular
    .module('application.scene.authorized.scene.calendar.component.calendar-day.component.calendar-day-event', [])
    .component(CalendarDayEventComponent.selector, CalendarDayEventComponent);



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/calendar/component/calendar-day/component/calendar-day-event/index.js